import React from 'react';
import { useTranslation } from 'react-i18next';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SearchAndFilters = ({
  searchInput,
  onSearchInputChange,
  onSearchSubmit,
  statusFilter,
  onStatusFilterChange,
  contactFilter,
  onContactFilterChange,
  totalCandidates,
  canPrioritize = false,
}) => {
  const { t } = useTranslation();

  const statusOptions = [
    { value: 'all', label: t('candidates.statusAll') },
    { value: 'pending', label: t('candidates.statusPending') },
    { value: 'active-seeker', label: t('candidates.statusActiveSeeker') },
    { value: 'potential-seeker', label: t('candidates.statusPotentialSeeker') },
    { value: 'stable', label: t('candidates.statusStable') },
    { value: 'unavailable', label: t('candidates.statusUnavailable') },
    { value: 'manual', label: t('candidates.statusManual') },
    ...(canPrioritize ? [{ value: 'prioritized', label: t('candidates.statusPrioritized') }] : [])
  ];

  const contactOptions = [
    { value: 'all', label: t('candidates.contactAll') },
    { value: 'linkedin-blocked', label: t('candidates.contactLinkedinBlocked') },
    { value: 'linkedin-available', label: t('candidates.contactLinkedinAvailable') },
    { value: 'phone-missing', label: t('candidates.contactPhoneMissing') },
    { value: 'phone-available', label: t('candidates.contactPhoneAvailable') },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row gap-4 lg:gap-6 lg:items-end">
        <div className="flex-1">
          <div className="flex w-full gap-2 items-end">
            <div className="flex-1 min-w-0">
              <Input
                label={t('candidates.searchLabel')}
                type="search"
                placeholder={t('candidates.searchPlaceholder')}
                value={searchInput}
                onChange={(e) => onSearchInputChange(e?.target?.value)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                    onSearchSubmit?.();
                  }
                }}
                className="w-full"
              />
            </div>
            <Button
              type="button"
              variant="default"
              size="icon"
              iconName="Search"
              onClick={onSearchSubmit}
              aria-label={t('candidates.searchAria')}
              className="shrink-0"
            />
          </div>
        </div>
        
        <div className="w-full lg:w-64">
          <Select
            label={t('candidates.filterStatus')}
            options={statusOptions}
            value={statusFilter}
            onChange={onStatusFilterChange}
            placeholder={t('candidates.selectStatus')}
          />
        </div>

        <div className="w-full lg:w-64">
          <Select
            label={t('candidates.filterContact')}
            options={contactOptions}
            value={contactFilter}
            onChange={onContactFilterChange}
            placeholder={t('candidates.selectContact')}
          />
        </div>
        
        <div className="flex items-center gap-2 text-sm text-muted-foreground bg-muted px-4 py-3 rounded-lg whitespace-nowrap">
          <Icon name="Users" size={16} />
          <span className="font-medium">{t('common.totalMonitored', { count: totalCandidates })}</span>
        </div>
      </div>
    </div>
  );
};

export default SearchAndFilters;
